module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921024149_T.38be79ae.jpg";